import {
  setQuestionnairesById,
  setCompletedQuestionnaires,
  setPendingTopicsQuestionnaires,
} from "../slices/questionnaires.slice";
import api from "../../services/api";
import { initLoading, endLoading } from "../slices/generics.slice";

export const getPendingQuestionnaires = () => {
  return async (dispatch, getState) => {
    dispatch(initLoading());

    try {
      const id = getState().userReducer?.user?.id;
      const response = await api.get(`/questionnaires/pending/${id}`);

      if (!response.data.success) return [];

      await dispatch(setPendingTopicsQuestionnaires(response.data.result.items));
      return response.data.result.items;
    } catch (error) {
      console.log("getPendingQuestionnaires", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getQuestionnairesById = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/questionnaires/${id}/get`);

      if (!response.data.success) return [];
      await dispatch(setQuestionnairesById(response.data.result.items));
    } catch (error) {
      console.log("getQuestionnairesById", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postAnswerQuestionnaires = (params) => {
  return async (dispatch, getState) => {
    dispatch(initLoading());

    const userId = getState().userReducer?.user?.id;
    const payload = JSON.stringify({ userId, ...params });

    try {
      const response = await api.post(`/questionnaires/${params.questionnaireId}/answer`, payload);
      return response.data.success;
    } catch (error) {
      console.log("postQuestionnaires", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getCompletedQuestionnaires = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/questionnaires/answers/${id}`);

      if (!response.data.success) return [];
      await dispatch(setCompletedQuestionnaires(response.data.result.items));
    } catch (error) {
      console.log("getCompletedQuestionnaires", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};
